module.exports = __webpack_public_path__ + "img/QR-img2.aaafa52b.png";